import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("th", { scope: "row" }, "LV03:", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("th", { scope: "row" }, "WGS84:", -1)
const _hoisted_3 = { scope: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h4", null, _toDisplayString($props.title), 1),
    _createElementVNode("table", null, [
      _createElementVNode("tr", null, [
        _hoisted_1,
        _createElementVNode("td", null, _toDisplayString($options.formatCoordinatesLV03($props.coordinates)), 1)
      ]),
      _createElementVNode("tr", null, [
        _hoisted_2,
        _createElementVNode("td", null, _toDisplayString($options.formatCoordinatesWGS84Decimal($options.LV03toWGS84($props.coordinates))), 1)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.getUserGridIdentifiers(), (arr) => {
        return (_openBlock(), _createElementBlock("tr", {
          key: arr[0]
        }, [
          _createElementVNode("th", _hoisted_3, _toDisplayString(arr[1]), 1),
          _createElementVNode("td", null, _toDisplayString(arr[2]), 1)
        ]))
      }), 128))
    ])
  ], 64))
}